/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/defense_1': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M11.055 19.081c.787 1.54 4.273 3.84 4.668 4.103l.278.152.278-.203c.413-.277 4.043-2.605 4.678-4.041L21 11H11l.055 8.081zM12 12h8l-.018 6.48c-.365 1.351-3.162 3.08-3.718 3.428L16 22l-.265-.165c-.334-.208-3.273-2.077-3.713-3.483l-.022-.15V12z"/><path pid="1" d="M16 20.816c1.193-.78 2.752-2.012 3-2.691V13h-6v5.116c.299.745 1.885 1.971 3 2.7z"/><path pid="2" d="M28 19.354L31.354 16 28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646zM30.646 16L28 18.646v-5.293L30.646 16zM16 1.354L18.646 4h-5.293L16 1.354zM1.354 16L4 13.354v5.292L1.354 16zM16 30.646L13.354 28h5.292L16 30.646zM26 26H6V6h20v20z"/>'
  }
})
